var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulkOrder = function SvgBulkOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 10.28 9.735 4.281v13.064l-8.654-3.51A1.73 1.73 0 0 1 2 22.508zm22.575-.502-.165 11.865c-.01.7-.441 1.327-1.092 1.586l-11.002 4.38V14.552zm-9.411-4.57 8.962 4.13-12.105 4.719-9.574-4.213L13.78 5.179a1.73 1.73 0 0 1 1.385.029",
    className: "BulkOrder_svg__FlowIcon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.726 6.625 8.377 4.116.747.916-1.074.419.8-.31v3.61L16.533 16.6v-3.651l.011-.004-.849-.869-8.445-4.04z",
    className: "BulkOrder_svg__flowIconSnowStorm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 15.28 9.735 4.281v13.064l-8.654-3.51A1.73 1.73 0 0 1 23 27.508zm22.575-.502-.165 11.865c-.01.7-.441 1.327-1.092 1.586l-11.002 4.38V19.552zm-9.41-4.57 8.96 4.13-12.104 4.719L23.5 14.84l11.278-4.66a1.73 1.73 0 0 1 1.387.028",
    className: "BulkOrder_svg__FlowIcon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.726 11.625 8.377 4.116.747.916-1.074.419.8-.31v3.61L37.533 21.6v-3.651l.011-.004-.849-.869-8.445-4.04z",
    className: "BulkOrder_svg__flowIconSnowStorm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 26.28 9.735 4.281v13.064l-8.654-3.51A1.73 1.73 0 0 1 5 38.508zm22.575-.502-.165 11.865c-.01.7-.441 1.327-1.092 1.586l-11.002 4.38V30.552zm-9.411-4.57 8.962 4.13-12.105 4.719-9.574-4.213 11.332-4.665a1.73 1.73 0 0 1 1.385.029",
    className: "BulkOrder_svg__FlowIcon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.726 22.625 8.377 4.116.747.916-1.074.419.8-.31v3.61L19.533 32.6v-3.651l.011-.004-.849-.869-8.445-4.04z",
    className: "BulkOrder_svg__flowIconSnowStorm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 46c5.523 0 10-4.477 10-10a9.98 9.98 0 0 0-3.547-7.64A9.96 9.96 0 0 0 36 26c-5.523 0-10 4.477-10 10a9.99 9.99 0 0 0 4.332 8.24A9.95 9.95 0 0 0 36 46",
    className: "BulkOrder_svg__flowIconReversed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 34v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z",
    className: "BulkOrder_svg__flowIconPrimary"
  }))));
};
export default SvgBulkOrder;